import { faCheckCircle, faCreditCard, faExclamationTriangle, faPencil, faQuestionCircle, faStopCircle, faTimesCircle, faCircleDot, faClock } from '@fortawesome/pro-regular-svg-icons';
export const STATUS_ICON_MAP = {
  confirmed: faCheckCircle,
  'confirmed:soon': faClock,
  'confirmed:present': faCircleDot,
  'confirmed:past': faCheckCircle,
  awaiting_payment: faCreditCard,
  pencilled_in: faPencil,
  requested: faQuestionCircle,
  cancelled: faTimesCircle,
  denied: faStopCircle,
  no_show: faExclamationTriangle
};
export const STATUS_COLOR_MAP: Record<string, string> = {
  confirmed: 'green',
  'confirmed:future': 'green',
  'confirmed:soon': 'blue',
  'confirmed:present': 'blue',
  'confirmed:past': 'gray',
  awaiting_payment: 'red',
  pencilled_in: 'yellow',
  requested: 'yellow',
  cancelled: 'red',
  denied: 'red',
  no_show: 'red'
};